<template>
    <UModal :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
        <UCard>
            <template #header>
                <div class="flex items-center justify-between">
                    <h3 class="text-lg font-semibold">Complete Transport</h3>
                    <UButton icon="i-ph-x" variant="ghost" color="gray" @click="$emit('update:modelValue', false)" />
                </div>
            </template>

            <div class="space-y-4">
                <UFormGroup label="Final Price" required :error="priceError">
                    <UInput v-model="price" type="number" min="0" placeholder="0" size="xl">
                        <template #leading>
                            <span class="text-gray-400 text-sm">$</span>
                        </template>
                    </UInput>
                </UFormGroup>
                <UFormGroup label="Remarks">
                    <UTextarea v-model="remarks" placeholder="Optional remarks..." size="xl" />
                </UFormGroup>
            </div>

            <template #footer>
                <div class="flex gap-3 justify-end">
                    <UButton color="gray" variant="ghost" @click="$emit('update:modelValue', false)">Cancel</UButton>
                    <UButton color="emerald" :loading="submitting" @click="submit">Complete</UButton>
                </div>
            </template>
        </UCard>
    </UModal>
</template>

<script setup lang="ts">
const props = defineProps<{
    modelValue: boolean
    submitting?: boolean
    initialPrice?: number | null
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', value: boolean): void
    (e: 'submit', payload: { price: number; remarks: string | null }): void
}>()

const price = ref<string>(props.initialPrice != null ? String(props.initialPrice) : '')
const remarks = ref('')
const priceError = ref<string | undefined>()

watch(() => props.modelValue, (open) => {
    if (open) {
        price.value = props.initialPrice != null ? String(props.initialPrice) : ''
        remarks.value = ''
        priceError.value = undefined
    }
})

function submit() {
    const n = Number(price.value)
    if (!Number.isFinite(n) || n < 0 || price.value === '') {
        priceError.value = 'Enter a valid price'
        return
    }
    priceError.value = undefined
    emit('submit', { price: n, remarks: remarks.value.trim() || null })
}
</script>
